import { inject } from 'vue'
import { ProviderKeys } from '@/app/providers/provider-keys.ts'

export function useTheme() {
  const theme = inject(ProviderKeys.AppTheme)

  if (!theme) {
    throw new Error('Could not find provider ThemeProvider')
  }
  return theme
}
